(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const countrySelectors = document.querySelectorAll('.popout-list__option');

    countrySelectors.forEach(selector => {
      selector.addEventListener('click', function () {
        const countryCode = this.getAttribute('data-country-code');
        const countryLanguage = this.getAttribute('data-country-language');
        
        // Store the selected country in localStorage
        // localStorage.setItem('SELECTED_COUNTRY', countryCode);
        // localStorage.setItem('SELECTED_LANGUAGE', countryLanguage.toLowerCase().slice(0, 2));
        
        updateLocalization({ country: countryCode, language: countryLanguage.toLowerCase().slice(0, 2) });
      });
    });
  });

  function updateLocalization({ country, language }) {
    if (country === 'UK') {
      country = 'GB';
    }

    if (country === 'EU') {
      country = 'DE';
    }

    const formId = crypto.randomUUID();
    const formHtml = `
    <form id="${formId}" action="/localization" method="POST" hidden>
      <input name="_method" value="PUT">
      <input name="country_code" value="${country}">
      <input name="language_code" value="${language}">
    </form>
  `;
    document.body.insertAdjacentHTML("beforeend", formHtml);
    document.getElementById(formId).submit();
  }

  class CountrySelector extends HTMLElement {
    constructor() {
      super();
      console.log('CountrySelector initialized');
      this.LOCAL_STORAGE_KEY = 'COUNTRY_CHECKED_2025';
      this.SELECTED_COUNTRY_KEY = 'SELECTED_COUNTRY';
      this.SELECTED_LANGUAGE_KEY = 'SELECTED_LANGUAGE';
      this.currentCountry = this.getAttribute('data-current-country');
      this.currentLanguage = this.getAttribute('data-current-language');
      if (this.currentCountry == "GB") {
        this.currentCountry = "UK";
      }

      if (this.currentCountry == "DE") {
        this.currentCountry = "EU";
      }

      console.log('Current country:', this.currentCountry);
      console.log('Current language:', this.currentLanguage);

      // Check if user has a stored country preference and redirect if needed
      this.checkStoredCountryPreference();

      if (this.hasCountryBeenChecked()) {
        console.log('Country already checked, returning early');
        return;
      }

      const _this = this;

      const closeButton = this.querySelector('[data-popup-close]');
      if (closeButton) {
        console.log('Found close button');
        closeButton.addEventListener('click', () => {
          _this.removeCountrySelector();
          localStorage.setItem(_this.LOCAL_STORAGE_KEY, 'true');
        });
      } else {
        console.log('Close button not found');
      }

      this.addEventListener('click', (event) => {
        if (!event.target.closest('.country-selector__content')) {
          console.log('Clicked outside content, closing');
          _this.removeCountrySelector();
          localStorage.setItem(_this.LOCAL_STORAGE_KEY, 'true');
        }
      });

      this.checkGeolocation();

      const links = [...this.querySelectorAll(".popout-list__option")];
      this.countryCodes = links.map(link => link.dataset.countryCode);

      links.forEach((link) => {
        link.addEventListener("click", () => {
          const countryCode = link.getAttribute('data-country-code');
          const countryLanguage = link.getAttribute('data-country-language');
          
          // Store the selected country in localStorage
          // localStorage.setItem('SELECTED_COUNTRY', countryCode);
          // localStorage.setItem('SELECTED_LANGUAGE', countryLanguage.toLowerCase().slice(0, 2));
          localStorage.setItem(_this.LOCAL_STORAGE_KEY, 'true');
          
          _this.removeCountrySelector();
          
          // Switch to the selected country
          updateLocalization({ 
            country: countryCode, 
            language: countryLanguage.toLowerCase().slice(0, 2) 
          });
        });
      });
    }

    checkStoredCountryPreference() {
      const isDesignMode = document.documentElement.classList.contains('is-design-mode');
      if (isDesignMode) {
        console.log('Design mode detected. Not checking for stored country preference.');
        return;
      }

      const overrideCountryQuery = new URLSearchParams(window.location.search).get('country');

      if(overrideCountryQuery || document.referrer.includes('day-et')) {
        console.log('Override country query detected:', overrideCountryQuery);

        localStorage.setItem(this.LOCAL_STORAGE_KEY, 'true');
        localStorage.removeItem(this.SELECTED_COUNTRY_KEY);
        localStorage.removeItem(this.SELECTED_LANGUAGE_KEY);
        return;
      }

      // const storedCountry = localStorage.getItem(this.SELECTED_COUNTRY_KEY);
      // const storedLanguage = localStorage.getItem(this.SELECTED_LANGUAGE_KEY);

      // console.log('Stored country:', storedCountry);
      // console.log('Stored language:', storedLanguage);
      
      // if (storedCountry && storedCountry !== this.currentCountry) {
      //   console.log('Stored country preference detected:', storedCountry, 'current:', this.currentCountry);
      //   console.log('Redirecting to stored country preference');
        
      //   // Use the existing updateLocalization function to redirect
      //   updateLocalization({ 
      //     country: storedCountry, 
      //     language: storedLanguage || 'en' 
      //   });
      // }
    }

    checkGeolocation() {
      if (localStorage.getItem(this.LOCAL_STORAGE_KEY) !== 'true') {
        if (window.Shopify && window.Shopify.designMode !== true) {
          console.log('Fetching geolocation data from ipapi.co');
          fetch('https://ipapi.co/json/')
            .then((response) => response.json())
            .then((data) => {
              console.log('Geolocation data received:', data);
              
              if (this.shouldShowPopup(data)) {
                console.log('Should show popup for country:', data.country);
                setTimeout(() => {
                  this.showCountrySelector();
                }, 450);
              } else {
                console.log('No need to show popup');
                localStorage.setItem(this.LOCAL_STORAGE_KEY, 'true');
              }
            })
            .catch((error) => {
              console.error('Error fetching geolocation:', error);
              localStorage.setItem(this.LOCAL_STORAGE_KEY, 'true');
            });
        }
      }
    }

    shouldShowPopup(geo) {
      const detectedCountryCode = geo.country || geo.country_code;
      const detectedContinentCode = geo.continent_code;

      console.log('Checking if should show popup for:', detectedCountryCode);

      const countryCodes = this.countryCodes;

      if (detectedCountryCode !== this.currentCountry) {
        if (!countryCodes.includes(this.currentCountry) && detectedContinentCode == "EU") {
          console.log('Should not show - EU country detected');
          return false;
        }

        console.log('Should show - different country detected');
        return true;
      }

      console.log('Should not show popup');
      return false;
    }

    showCountrySelector() {
      if (this) {
        this.classList.add("show");
      }
    }

    removeCountrySelector() {
      console.log('Removing country selector');
      if (this) {
        this.classList.remove("show");
      }
    }

    hasCountryBeenChecked() {
      const checked = typeof window !== 'undefined'
        ? localStorage.getItem(this.LOCAL_STORAGE_KEY)
        : true;

      console.log('Has country been checked:', checked);
      return checked;
    }
  }

  customElements.define("country-selector", CountrySelector);

  // PopoutSelect custom element for header/footer dropdowns
  class PopoutSelect extends HTMLElement {
    constructor() {
      super();
      this.popoutToggle = this.querySelector('[data-popout-toggle]');
      this.popoutList = this.querySelector('[data-popout-list]');
      
      if (this.popoutToggle && this.popoutList) {
        this.popoutToggle.addEventListener('click', this.onPopupToggleClick.bind(this));
        this.bodyClickEvent = this.onBodyClick.bind(this);
      }
    }

    onPopupToggleClick(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      
      const button = evt.currentTarget;
      const ariaExpanded = button.getAttribute('aria-expanded') === 'true';

      // Close all other popouts first
      document.querySelectorAll('popout-select [data-popout-toggle]').forEach(otherButton => {
        if (otherButton !== button && otherButton.getAttribute('aria-expanded') === 'true') {
          otherButton.setAttribute('aria-expanded', 'false');
          const otherList = otherButton.closest('popout-select').querySelector('[data-popout-list]');
          if (otherList) {
            otherList.classList.remove('popout-list--visible');
          }
        }
      });

      // Toggle this popout
      button.setAttribute('aria-expanded', !ariaExpanded);
      this.popoutList.classList.toggle('popout-list--visible');

      if (!ariaExpanded) {
        document.body.addEventListener('click', this.bodyClickEvent);
      } else {
        document.body.removeEventListener('click', this.bodyClickEvent);
      }
    }

    onBodyClick(evt) {
      if (!this.contains(evt.target)) {
        this.popoutToggle.setAttribute('aria-expanded', 'false');
        this.popoutList.classList.remove('popout-list--visible');
        document.body.removeEventListener('click', this.bodyClickEvent);
      }
    }
  }

  customElements.define("popout-select", PopoutSelect);
})();